import {Component, OnDestroy, OnInit} from '@angular/core';
import {NouvelleVersionDisponibleService} from './nouvelle-version-disponible.service';
import {Version} from './version.model';
import {Subscription} from 'rxjs';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AlertComponent} from '../../alert/alert.component';
import {TranslateModule} from '@ngx-translate/core';
import {AbstractSigaleComponent} from '../../abstract-sigale.component';

@Component({
	standalone: true,
	selector: 'nouvelle-version-disponible',
	templateUrl: 'nouvelle-version-disponible.component.html',
	styleUrls: ['./nouvelle-version-disponible.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		AlertComponent,
		TranslateModule
	]
})

export class NouvelleVersionDisponibleComponent extends AbstractSigaleComponent implements OnDestroy {

	nouvelleVersionDisponible = false;
	versionSubscription: Subscription;

	constructor(private nouvelleVersionDisponibleService: NouvelleVersionDisponibleService) {
		super();
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.versionSubscription = this.nouvelleVersionDisponibleService.getVersion().subscribe((version: Version) => {
			this.nouvelleVersionDisponible = true;
		});
	}

	ngOnDestroy(): void {
		if (this.versionSubscription) {
			this.versionSubscription.unsubscribe();
		}
	}

	/**
	 * Force le rafraissement de l'application
	 */
	rafraichir() {
		// Pour forcer le rafraichissement et vider le cache (window.location.reload(true) est déprécié)
		window.location.href = window.location.href;
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"NOUVELLE_VERSION": {
						"LABEL_ATTENTION": "Attention :",
						"MESSAGE": "Une nouvelle version a été installée, le S.I Sigale vous propose de faire la mise à jour en cliquant sur",
						"LABEL_OK": "OK"
					}
				}
			}
		};
	}


	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"NOUVELLE_VERSION": {
						"LABEL_ATTENTION": "Attenzione :",
						"MESSAGE": "è stata installata una nuova versione, S.I. Sigale ti propone di eseguire l'aggiornamento cliccando su",
						"LABEL_OK": "OK"
					}
				}
			}
		};
	}

}
